import { useEffect } from "react";

const ELFSIGHT_SRC = "https://elfsightcdn.com/platform.js";
const WIDGET_CLASS = "elfsight-app-9bec3214-cd73-46b6-9629-1698747e7158";

export default function GoogleReviews() {
  useEffect(() => {
    // Charge le script Elfsight une seule fois
    if (!document.querySelector(`script[src="${ELFSIGHT_SRC}"]`)) {
      const s = document.createElement("script");
      s.src = ELFSIGHT_SRC;
      s.async = true;
      document.body.appendChild(s);
    } else if (window.eapps && typeof window.eapps.initWidgetsFromBuffer === "function") {
      // Si le script est déjà là (navigation interne), on relance le rendu du widget
      window.eapps.initWidgetsFromBuffer();
    }
  }, []);

  return (
    <section className="relative py-16 border-t border-white/5" data-testid="google-reviews-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-xs uppercase tracking-[0.3em] text-[#E50914] font-bold mb-4">/ Avis Google vérifiés</div>
        <h2 className="text-3xl sm:text-4xl font-black tracking-tighter mb-8">
          Nos avis <span className="text-gradient-red">Google.</span>
        </h2>
        {/* Widget Elfsight — Google Reviews */}
        <div className={WIDGET_CLASS} data-elfsight-app-lazy></div>
      </div>
    </section>
  );
}
